// import Swiper core and required modules
import PeopleBlocksFlat from '../../elements/peeps/PeopleBlocksFlat';
import SwiperPeopleStyles from '../../../styles/elements/people/SwiperPeopleStylesFlat.module.scss';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// import Swiper core and required modules
import SwiperCore, { EffectCoverflow, Pagination, Navigation } from 'swiper/core';

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination, Navigation]);

const PeopleSliderFlat = ({ People, numberOfSlidesOnLarge, headingColor = '#2D5092', borderColor = '#efc4cf', centeredSlides }) => {
  return (
    <div className="container" style={{ padding: `0` }}>
      <Swiper
        className="flatSlider m-auto"
        spaceBetween={30}
        navigation={true}
        watchOverflow={true}
        centeredSlidesBounds={true}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 10,
            initialSlide: 2
          },
          1200: {
            slidesPerView: numberOfSlidesOnLarge,
            spaceBetween: 10,
            initialSlide: 0
          }
        }}
        grabCursor={false}
        centeredSlides={false}
      >
        {People?.length > 0 &&
          People.map((person) => (
            <SwiperSlide key={person._id} className={SwiperPeopleStyles.aSlide}>
              <PeopleBlocksFlat person={person} headingColor={headingColor} borderColor={borderColor} />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default PeopleSliderFlat;
